import { Fragment } from 'react';

import { InvoiceEventViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { Assets, Box, Container, Flex, Headings, Line, Text } from '@foradevelopment/fora-ui';
import { dateStringFormatter } from '@fora-monorepo/date-utils';
import { swedishNumberFormatter } from '@fora-monorepo/string-utils';

import { getEventTypeText } from '../utils';
import { useTypedTranslation } from '../../i18n/i18n';

type InvoiceEventLogProps = {
  title: string;
  list: InvoiceEventViewModel[];
  loading: boolean;
  error: boolean;
};

export const InvoiceEventLog = ({ title, list, loading, error }: InvoiceEventLogProps) => {
  const { t } = useTypedTranslation();

  return (
    <Container marginTop={40}>
      <Headings.H5>{title}</Headings.H5>
      <Line color="black20" marginTop={10} marginBottom={10} />
      {loading ? (
        <Flex>
          <Assets.Loading width={40} marginLeft="auto" marginRight="auto" marginTop={40} color="black20" />
        </Flex>
      ) : list.length ? (
        list.map((item, index) => {
          return (
            <Fragment key={`InvoiceEvent-log-key-${index}`}>
              <Flex columnGap={[10, 40, 40]} rowGap={6} flexWrap="wrap">
                <Box flexBasis={[0, 0, 0]} flexGrow={1}>
                  <Text size="small">{dateStringFormatter(item.date)}</Text>
                </Box>
                <Box flexBasis={[0, 0, 0]} flexGrow={1}>
                  <Text size="small" color="black70">
                    {getEventTypeText(item.type, t)}
                    {item.paymentDeferralDueDate &&
                      ' ' +
                        t('list.invoiceEvents.eventPaymentDeferralDueDate', {
                          paymentDeferralDueDate: item.paymentDeferralDueDate,
                        })}
                  </Text>
                </Box>
                <Box flexBasis={[0, 0, 0]} flexGrow={1}>
                  <Text size="small" textAlign="right">
                    {item.amount !== null ? swedishNumberFormatter(item.amount) + ' kr' : null}
                  </Text>
                </Box>
              </Flex>
              <Line color="black20" marginTop={10} marginBottom={10} />
            </Fragment>
          );
        })
      ) : error ? (
        <Text size="small">{t('list.invoiceEvents.eventError')}</Text>
      ) : (
        <Text size="small">{t('list.invoiceEvents.noEvents')}</Text>
      )}
    </Container>
  );
};
